import {
    DeviceUserDTO,
    EditUserInfoRequest,
    GetUsersDTO,
    InviteUsersDTO,
    ResendEmailsDTO,
    StatusType,
    UserActivitySocket,
    UserIdDTO,
    UserMobileDeviceConfigurationsDTO,
    UserPermissionAndStatus,
    UserProfileSocket,
    UsersProfile,
    UsersSettings,
    UserStatusDTO,
} from '.';
import { Deferred } from '../../../utils/PromiseCreator';

export enum USERS {
    GET_USERS_REQUEST = 'USERS.GET_USERS_REQUEST',
    GET_USERS_SUCCESS = 'USERS.GET_USERS_SUCCESS',
    GET_USERS_FAILURE = 'USERS.GET_USERS_FAILURE',

    DELETE_USER_REQUEST = 'USERS.DELETE_USER_REQUEST',
    DELETE_USER_SUSSESS = 'USERS.DELETE_USER_SUSSESS',
    DELETE_USER_FAILURE = 'USERS.DELETE_USER_FAILURE',

    CHANGE_STATUS_REQUEST = 'USERS.CHANGE_STATUS_REQUEST',
    CHANGE_STATUS_SUSSESS = 'USERS.CHANGE_STATUS_SUSSESS',
    CHANGE_STATUS_FAILURE = 'USERS.CHANGE_STATUS_FAILURE',

    INVITE_USERS_REQUEST = 'USERS.INVITE_USERS_REQUEST',
    INVITE_USERS_SUSSESS = 'USERS.INVITE_USERS_SUSSESS',
    INVITE_USERS_FAILURE = 'USERS.INVITE_USERS_FAILURE',

    RESEND_MAIL_USERS_REQUEST = 'USERS.RESEND_MAIL_USERS_REQUEST',
    RESEND_MAIL_USERS_SUSSESS = 'USERS.RESEND_MAIL_USERS_SUSSESS',
    RESEND_MAIL_USERS_FAILURE = 'USERS.RESEND_MAIL_USERS_FAILURE',

    EDIT_USER_INFO_REQUEST = 'USERS.EDIT_USER_INFO_REQUEST',
    EDIT_USER_INFO_SUSSESS = 'USERS.EDIT_USER_INFO_SUSSESS',
    EDIT_USER_INFO_FAILURE = 'USERS.EDIT_USER_INFO_FAILURE',

    EDIT_PEMISSION_AND_STATUS_REQUEST = 'USERS.EDIT_PEMISSION_AND_STATUS_REQUEST',
    EDIT_PEMISSION_AND_STATUS_SUSSESS = 'USERS.EDIT_PEMISSION_AND_STATUS_SUSSESS',
    EDIT_PEMISSION_AND_STATUS_FAILURE = 'USERS.EDIT_PEMISSION_AND_STATUS_FAILURE',

    UPDATE_STATUS_BY_SOCKET = 'USERS.UPDATE_STATUS_BY_SOCKET',
    DELETE_BY_SOCKET = 'USERS.DELETE_USER_BY_SOCKET',
    INVITE_BY_SOCKET = 'USERS.INVITE_BY_SOCKET',
    GET_PROFILE_BY_SOCKET = 'USERS.GET_PROFILE_BY_SOCKET',
    UPDATE_ACTIVITY_STATUS_BY_SOCKET = 'USERS.UPDATE_ACTIVITY_STATUS_BY_SOCKET',

    SUSSESS = 'USERS.SUSSESS',
    FAILURE = 'USERS.FAILURE',
    SET_SETTINGS = 'USERS.SET_LIST_SETTINGS',
    CHANGE_SELECTED = 'USERS.CHANGE_SELECTED',

    TRANSFER_OWNERSHIP_REQUEST = 'USERS.TRANSFER_OWNERSHIP_REQUEST',
    TRANSFER_OWNERSHIP_SUSSESS = 'USERS.TRANSFER_OWNERSHIP_SUSSESS',
    TRANSFER_OWNERSHIP_FAILURE = 'USERS.TRANSFER_OWNERSHIP_FAILURE',

    GET_USERS_PICTURE_REQUEST = 'USERS.GET_USERS_PICTURE_REQUEST',
    GET_USERS_PICTURE_SUCCESS = 'USERS.GET_USERS_PICTURE_SUCCESS',
    GET_USERS_PICTURE_FAILURE = 'USERS.GET_USERS_PICTURE_FAILURE',

    ADD_DEVICE_REQUEST = 'USERS.ADD_DEVICE_REQUEST',
    ADD_DEVICE_SUCCESS = 'USERS.ADD_DEVICE_SUCCESS',
    ADD_DEVICE_FAILURE = 'USERS.ADD_DEVICE_FAILURE',

    DELETE_DEVICE_REQUEST = 'USERS.DELETE_DEVICE_REQUEST',
    DELETE_DEVICE_SUCCESS = 'USERS.DELETE_DEVICE_SUCCESS',
    DELETE_DEVICE_FAILURE = 'USERS.DELETE_DEVICE_FAILURE',

    GET_USERS_MOBILE_DEVICES_REQUEST = 'USERS.GET_USERS_MOBILE_DEVICES_REQUEST',
    GET_USERS_MOBILE_DEVICES_SUCCESS = 'USERS.GET_USERS_MOBILE_DEVICES_SUCCESS',
    GET_USERS_MOBILE_DEVICES_FAILURE = 'USERS.GET_USERS_MOBILE_DEVICES_FAILURE',

    SET_USERS_MOBILE_DEVICES_REQUEST = 'USERS.SET_USERS_MOBILE_DEVICES_REQUEST',
    SET_USERS_MOBILE_DEVICES_SUCCESS = 'USERS.SET_USERS_MOBILE_DEVICES_SUCCESS',
    SET_USERS_MOBILE_DEVICES_FAILURE = 'USERS.SET_USERS_MOBILE_DEVICES_FAILURE',

    DELETE_DEVICE_FROM_USER_BYSOCKET = 'USERS.DELETE_DEVICE_FROM_RESIDENT_BYSOCKET',
    ADD_DEVICE_TO_USER_BY_SOCKET = 'USERS.ADD_DEVICE_TO_RESIDENT_BY_SOCKET',
    USER_DEVICE_CONFIG_UPDATED = 'USERS.USER_DEVICE_CONFIG_UPDATED',
}

export interface IUsersGetRequest {
    type: typeof USERS.GET_USERS_REQUEST;
    payload: GetUsersDTO;
}
export interface IUsersGetSuccess {
    type: typeof USERS.GET_USERS_SUCCESS;
    payload: any[];
}
export interface IUsersGetFailure {
    type: typeof USERS.GET_USERS_FAILURE;
    payload: any;
}

export interface IDeleteUsersRequest {
    type: typeof USERS.DELETE_USER_REQUEST;
    payload: string[];
}
export interface IDeleteUsersSuccess {
    type: typeof USERS.DELETE_USER_SUSSESS;
    payload: any;
}
export interface IDeleteUsersFailure {
    type: typeof USERS.DELETE_USER_FAILURE;
    payload: any;
}

export interface IChangeUsersStatusRequest {
    type: typeof USERS.CHANGE_STATUS_REQUEST;
    payload: { ids: string[]; status: StatusType };
}
export interface IChangeUsersStatusSuccess {
    type: typeof USERS.CHANGE_STATUS_SUSSESS;
}
export interface IChangeUsersStatusFailure {
    type: typeof USERS.CHANGE_STATUS_FAILURE;
}

export interface IInviteUsersRequest {
    type: typeof USERS.INVITE_USERS_REQUEST;
    payload: InviteUsersDTO;
}
export interface IInviteUsersSuccess {
    type: typeof USERS.INVITE_USERS_SUSSESS;
}
export interface IInviteUsersFailure {
    type: typeof USERS.INVITE_USERS_FAILURE;
}

export interface IResendEmailUsersRequest {
    type: typeof USERS.RESEND_MAIL_USERS_REQUEST;
    payload: ResendEmailsDTO[];
}
export interface IResendEmailUsersSuccess {
    type: typeof USERS.RESEND_MAIL_USERS_SUSSESS;
}
export interface IResendEmailUsersFailure {
    type: typeof USERS.RESEND_MAIL_USERS_FAILURE;
}

export interface IEditUserInfoRequest {
    type: typeof USERS.EDIT_USER_INFO_REQUEST;
    payload: EditUserInfoRequest;
}
export interface IEditUserInfoSuccess {
    type: typeof USERS.EDIT_USER_INFO_SUSSESS;
    payload: UsersProfile;
}
export interface IEditUserInfoFailure {
    type: typeof USERS.EDIT_USER_INFO_FAILURE;
}

export interface IEditUserPermissionAndStatusRequest {
    type: typeof USERS.EDIT_PEMISSION_AND_STATUS_REQUEST;
    payload: UserPermissionAndStatus;
    deferredPromise: Deferred;
}
export interface IEditUserPermissionAndStatusSuccess {
    type: typeof USERS.EDIT_PEMISSION_AND_STATUS_SUSSESS;
    payload: any;
}
export interface IEditUserPermissionAndStatusFailure {
    type: typeof USERS.EDIT_PEMISSION_AND_STATUS_FAILURE;
    payload: any;
}

export interface ISetUsersSettings {
    type: typeof USERS.SET_SETTINGS;
    payload: UsersSettings;
}

export interface ISetUsersSelected {
    type: typeof USERS.CHANGE_SELECTED;
    payload: string;
}

export interface IUpdateUserStatusBySocket {
    type: typeof USERS.UPDATE_STATUS_BY_SOCKET;
    payload: UserStatusDTO;
}

export interface IDeleteUserBySocket {
    type: typeof USERS.DELETE_BY_SOCKET;
    payload: UserIdDTO;
}

export interface IReceiveInviteBySocket {
    type: typeof USERS.INVITE_BY_SOCKET;
    payload: UsersProfile;
}
export interface IGetUserProfileBySocket {
    type: typeof USERS.GET_PROFILE_BY_SOCKET;
    payload: UserProfileSocket;
}

export interface IGetUserActivityStatusSocket {
    type: typeof USERS.UPDATE_ACTIVITY_STATUS_BY_SOCKET;
    payload: UserActivitySocket;
}

export interface ITransferOwnershipRequest {
    type: typeof USERS.TRANSFER_OWNERSHIP_REQUEST;
    payload: { newOwnerId: string };
}
export interface ITransferOwnershipSuccess {
    type: typeof USERS.TRANSFER_OWNERSHIP_SUSSESS;
    payload: any;
}
export interface ITransferOwnershipFailure {
    type: typeof USERS.TRANSFER_OWNERSHIP_FAILURE;
    payload: any;
}

export interface IGetUsersPictureRequest {
    type: typeof USERS.GET_USERS_PICTURE_REQUEST;
}
export interface IGetUsersPictureSuccess {
    type: typeof USERS.GET_USERS_PICTURE_SUCCESS;
    payload: any[];
}
export interface IGetUsersPictureFailure {
    type: typeof USERS.GET_USERS_PICTURE_FAILURE;
    payload: any;
}
export interface IAddUserDeviceRequest {
    type: typeof USERS.ADD_DEVICE_REQUEST;
    payload: { userId: string; deviceId: string };
}

export interface IAddUserDeviceSuccess {
    type: typeof USERS.ADD_DEVICE_SUCCESS;
    payload: any;
}

export interface IAddUserDeviceFailure {
    type: typeof USERS.ADD_DEVICE_FAILURE;
    payload: any;
}

export interface IDeleteUserDeviceRequest {
    type: typeof USERS.DELETE_DEVICE_REQUEST;
    payload: { userId: string; deviceId: string };
}

export interface IDeleteUserDeviceSuccess {
    type: typeof USERS.DELETE_DEVICE_SUCCESS;
    payload: any;
}

export interface IDeleteUserDeviceFailure {
    type: typeof USERS.DELETE_DEVICE_FAILURE;
    payload: any;
}

export interface IGetUsersMobileDevicesRequest {
    type: typeof USERS.GET_USERS_MOBILE_DEVICES_REQUEST;
}

export interface IGetUsersMobileDevicesSuccess {
    type: typeof USERS.GET_USERS_MOBILE_DEVICES_SUCCESS;
    payload: any[];
}

export interface IGetUsersMobileDevicesFailure {
    type: typeof USERS.GET_USERS_MOBILE_DEVICES_FAILURE;
    payload: any;
}

export interface ISetUsersMobileDevicesRequest {
    type: typeof USERS.SET_USERS_MOBILE_DEVICES_REQUEST;
    payload: UserMobileDeviceConfigurationsDTO;
}

export interface ISetUsersMobileDevicesSuccess {
    type: typeof USERS.SET_USERS_MOBILE_DEVICES_SUCCESS;
    payload: any;
}

export interface ISetUsersMobileDevicesFailure {
    type: typeof USERS.SET_USERS_MOBILE_DEVICES_FAILURE;
    payload: any;
}

export interface IDeleteDeviceFromUserBySocket {
    type: typeof USERS.DELETE_DEVICE_FROM_USER_BYSOCKET;
    payload: DeviceUserDTO;
}
export interface IAddDeviceToUserBySocket {
    type: typeof USERS.ADD_DEVICE_TO_USER_BY_SOCKET;
    payload: DeviceUserDTO;
}

export interface IUserDeviceConfigUpdatedBySocket {
    type: typeof USERS.USER_DEVICE_CONFIG_UPDATED;
    payload: { userId: string; value: boolean };
}
export type UsersActionType =
    | IGetUsersMobileDevicesFailure
    | IGetUsersMobileDevicesRequest
    | IUserDeviceConfigUpdatedBySocket
    | IGetUsersMobileDevicesSuccess
    | IDeleteDeviceFromUserBySocket
    | IAddDeviceToUserBySocket
    | IUsersGetFailure
    | IUsersGetRequest
    | IUsersGetSuccess
    | IDeleteUsersFailure
    | IDeleteUsersSuccess
    | IDeleteUsersRequest
    | IEditUserInfoRequest
    | IEditUserInfoSuccess
    | IEditUserInfoFailure
    | IInviteUsersRequest
    | IInviteUsersSuccess
    | IInviteUsersFailure
    | IChangeUsersStatusRequest
    | IChangeUsersStatusFailure
    | IChangeUsersStatusSuccess
    | IEditUserPermissionAndStatusRequest
    | IEditUserPermissionAndStatusFailure
    | IEditUserPermissionAndStatusSuccess
    | ISetUsersSettings
    | IUpdateUserStatusBySocket
    | IDeleteUserBySocket
    | IReceiveInviteBySocket
    | IGetUserProfileBySocket
    | IGetUserActivityStatusSocket
    | ISetUsersSelected
    | IResendEmailUsersRequest
    | IResendEmailUsersSuccess
    | IResendEmailUsersFailure
    | ITransferOwnershipRequest
    | ITransferOwnershipSuccess
    | ITransferOwnershipFailure
    | IGetUsersPictureSuccess;
